import QuoteLinkApp from 'QuoteLinkApp';
import SelfServiceApp from 'SelfServiceApp';
import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAppType } from 'reducers/ui/uiSlice';
import { APP_TYPE } from 'shared/constants/common';
import { QUOTE_LINK_ROUTE_PREFIX } from 'shared/constants/quoteLinkRoutes';

export default function App() {
  const dispatch = useDispatch();
  const { appType } = useSelector((state) => state.ui);

  const configureAppType = useCallback(() => {
    const pathname = window?.location?.pathname || '';
    const isQuoteLinkUrl = new RegExp(`^${QUOTE_LINK_ROUTE_PREFIX}`, 'g').test(
      pathname,
    );
    dispatch(
      setAppType(isQuoteLinkUrl ? APP_TYPE.QUOTE_LINK : APP_TYPE.SELF_SERVICE),
    );
  }, [dispatch]);

  useEffect(() => {
    configureAppType();
  }, [configureAppType]);

  const renderApp = () => {
    switch (appType) {
      case APP_TYPE.QUOTE_LINK:
        return <QuoteLinkApp />;
      case APP_TYPE.SELF_SERVICE:
        return <SelfServiceApp />;
      default:
        return null;
    }
  };

  return renderApp();
}
